import History from "../../@history/index";

export const getArticleOptionsData = async ({ userData }) => {
    let responseData;
    let statusCode;
    let apiResponse;
    let message;
    const articleToken = userData?.ArticleToken;
    const articleKey = userData?.ArticleKey;
    const requestOptions = {
        method: "GET",
        headers: new Headers({
            'Content-Type': 'application/json',
            'apikey': articleKey,
            'Authorization': `Bearer ${articleToken}`
        })
    }
    await fetch(`${process.env.REACT_APP_ARTICLE_SERVICE}ADAPCatalog/V1/GetSuppliers`, requestOptions).then(async response => {
        responseData = response;

        statusCode = response?.status;
        message = response?.message
        apiResponse = await response.json()
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login');
        }
    }).catch(error => {
        if (statusCode === 401 || message === 'Invalid token or token expired' || apiResponse?.error?.statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login')
        }
        return false
    })
    if (statusCode === 200 && apiResponse) return apiResponse

}


export const getArticleData = async ({ userData, supplierName, articleNo, supplierId, region, CurrentLanguage, pageSize, page }) => {
    let responseData;
    let apiResponse;
    let statusCode;
    const articleToken = userData?.ArticleToken;
    const articleKey = userData?.ArticleKey;
    const apikey = userData?.SecretKey;
    const token = userData?.Token;
    const language = CurrentLanguage ? CurrentLanguage : 'en'
    const jsonData = {
        articleNo,
        supplierId,
        region,
        supplierName,
        pageSize,
        page
    }
    const body = JSON.stringify(jsonData)
    const requestOptions = {
        method: "POST",
        headers: new Headers({
            'Content-Type': 'application/json',
            'apikey': apikey,
            'Authorization': `Bearer ${token}`,
            'articleToken': articleToken,
            'language': language,
        }),
        body
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}vioservice/article`, requestOptions).then(async response => {
        responseData = response;
        statusCode = response?.status;
        apiResponse = await response.json()
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login');
        }
    }).catch((error) => {
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login');
        }
        return false
    })
    if (statusCode === 200 && apiResponse) return apiResponse
}

export const getArticleDataBypagination = async ({ userData, supplierName, articleNo, supplierId, region, CurrentLanguage, page, pageSize, filters ,changePagination}) => {
    let apiResponse;
    let statusCode;
    let message;
    const articleToken = userData?.ArticleToken;
    const articleKey = userData?.ArticleKey;
    const apikey = userData?.SecretKey;
    const token = userData?.Token;
    const language = CurrentLanguage ? CurrentLanguage : 'en'
    const jsonData = {
        articleNo,
        supplierId,
        region,
        supplierName,
        page,
        pageSize,
        filters,
        changePagination
    }
    const body = JSON.stringify(jsonData)
    const requestOptions = {
        method: 'POST',
        headers: new Headers({
            "Content-type": "application/json",
            'Authorization': `Bearer ${token}`,
            'articleToken': articleToken,
            'language': language,
            "apikey": apikey
        }),
        body
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}vioservice/article/pagination`, requestOptions).then(async (response) => {
        statusCode = response?.status;
        message = response?.message;
        apiResponse = await response.json()
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login');
        }
    }).catch(error => {
        if (statusCode === 401 || message == "Invalid token or token expired" || apiResponse?.error?.statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login')
        }
        return false
    })
    if (apiResponse) {
        return apiResponse
    }
}


export const exportArticleData = async ({ userData, body }) => {
    let responseData;
    let apiResponse;
    let statusCode;
    const articleToken = userData?.ArticleToken || '';
    const requestOptions = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
            'apikey': userData.SecretKey,
            'Authorization': `Bearer ${userData.Token}`,
            'articleToken': articleToken,
        }),
        body: JSON.stringify(body)
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}vioservice/articleExport`, requestOptions).then(async response => {
        responseData = response;
        apiResponse = await response.json()
        statusCode = response?.status;
        if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
            localStorage.removeItem("userData")
            History.push('/login');
        }
    }).catch((error) => {
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login')
        }
        return false
    })
    if (apiResponse) return apiResponse;
}

export const getArticlesDataByFile = async ({userData,articles,region,CurrentLanguage}) => {
    let responseData;
    let apiResponse;
    let statusCode;
    const articleToken = userData?.ArticleToken;
    const apiKey = userData?.SecretKey;
    const token = userData?.Token;
    const language = CurrentLanguage ? CurrentLanguage : "en"
    const jsonData = {
        articles,
        region,
    }
    const body = JSON.stringify(jsonData)
    const requestOptions = {
        method: "POST",
        headers: new Headers({
            "Content-type":"application/json",
            "apikey": apiKey,
            "Authorization": `Bearer ${token}`,
            "articleToken": articleToken,
            "langauge": language
        }),
        body
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}vioservice/multiple/articles`,requestOptions).then(async response => {
        responseData = response;
        statusCode = response?.status;
        apiResponse = await response.json()
        if(statusCode === 401){
            localStorage.removeItem("userData")
            History.push("/login")
        }
    }).catch((error) => {
        if(statusCode === 401){
            localStorage.removeItem("userData")
            History.push('/login');
        }
          return false
    })
    if (statusCode === 200 && apiResponse) return apiResponse
}